import { createAsyncThunk } from "@reduxjs/toolkit";
import fsrHttpInstance, { fsrHttpConfiguration } from "../serviceFsrClients";
import { normalizeEntity } from "../entities/diningTableSectionEntity";
import { setFlashError } from "../slices/commons/flashSliceCommon";

export const fetchDiningTableSections = createAsyncThunk(
	"datasources/diningTableSections/fetchDiningTableSections",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/dining-table-sections/index", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.diningTableSections);

			return normalized;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The dining table section could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const fetchDiningTableSection = createAsyncThunk(
	"datasources/diningTableSections/fetchDiningTableSection",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/dining-table-sections/view", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.diningTableSection);

			return normalized;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The dining table section could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);